import { render, staticRenderFns } from "./SubscriptionCenter.vue?vue&type=template&id=2b56370c&scoped=true"
import script from "./SubscriptionCenter.vue?vue&type=script&lang=js"
export * from "./SubscriptionCenter.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionCenter.vue?vue&type=style&index=0&id=2b56370c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56370c",
  null
  
)

export default component.exports